import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col w-full h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-[66px] justify-between p-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Stores")
  ])
], -1)
const _hoisted_4 = { class: "flex gap-2 justify-between items-center px-5 py-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("span", null, "+ Add New Store")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.40002 4.7999L12 4.7999M2.40002 11.9999H12M12 11.9999V14.3999M12 11.9999V9.5999M2.40002 19.1999H7.20002M12 19.1999L21.6 19.1999M16.8 11.9999H21.6M16.8 4.7999L21.6 4.7999M16.8 4.7999V7.1999M16.8 4.7999V2.3999M7.80002 21.5999V16.7999",
    stroke: "black",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = { class: "px-4 py-3" }
const _hoisted_8 = { class: "px-4 py-3" }
const _hoisted_9 = { class: "px-4 py-3" }
const _hoisted_10 = { class: "px-4 py-3" }
const _hoisted_11 = { class: "px-4 py-3" }
const _hoisted_12 = { class: "px-4 py-3" }
const _hoisted_13 = { class: "hidden xl:flex gap-2" }
const _hoisted_14 = { class: "flex flex-col gap-2 overflow-x-auto px-5 pt-3 pb-28" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"box-head justify-between\"><div class=\"flex gap-4 items-center\"><div class=\"w-14\"></div><div class=\"w-44\"><span class=\"text-order\">Store Name</span></div><div class=\"w-24\"><span class=\"text-order\">Category</span></div><div class=\"w-48\"><span class=\"text-order\">Address</span></div><div class=\"w-44\"><span class=\"text-order\">Email</span></div><div class=\"w-36\"><span class=\"text-order\">Owner</span></div><div class=\"flex justify-center w-16\"><span class=\"text-order\">Rating</span></div><div class=\"flex justify-center w-44\"><span class=\"text-order\">Working</span></div></div><div class=\"flex gap-4 items-center\"><div class=\"flex justify-center w-36\"><span class=\"text-order\">Status</span></div><div class=\"flex justify-end w-9\"></div></div></div>", 1)
const _hoisted_16 = { class: "flex gap-4 items-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-title" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text"
}
const _hoisted_22 = {
  key: 2,
  class: "text"
}
const _hoisted_23 = { class: "text truncate" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = { class: "flex flex-col gap-2 items-center justify-center w-44" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = ["id", "checked", "onChange", "disabled"]
const _hoisted_28 = ["for"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check" })
  ])
], -1)
const _hoisted_30 = { class: "flex gap-2 items-center" }
const _hoisted_31 = { class: "form-check" }
const _hoisted_32 = ["checked", "onChange"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Auto Open/Close", -1)
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "flex justify-end w-9" }
const _hoisted_36 = {
  key: 0,
  class: "w-screen h-screen fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  id: "overlay",
  class: "w-screen h-screen fixed top-0 left-0"
}, null, -1)
const _hoisted_38 = { class: "z-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_action = _resolveComponent("action")!
  const _component_PaginationView = _resolveComponent("PaginationView")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/stores/add" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_Menu, {
          as: "div",
          class: "relative inline-block xl:hidden"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_MenuButton, { class: "flex" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-in",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuItems, { class: "absolute right-0 top-8 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none py-2 z-50" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.selectedStoreFilter,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStoreFilter) = $event)),
                        "return-by": "'name'",
                        items: _ctx.Stores,
                        "track-by": "name",
                        "filter-by": "name",
                        "show-by": "name",
                        placeholder: "Store",
                        "show-close": true,
                        onSubmit: _cache[1] || (_cache[1] = (val) => _ctx.filterStores(val, 'store')),
                        onClose: _cache[2] || (_cache[2] = (val) => _ctx.filterStores({name: '', value: ''}, 'store'))
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.selectedCategoryFilter,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCategoryFilter) = $event)),
                        "return-by": "'name'",
                        items: _ctx.Categories,
                        "track-by": "name",
                        "filter-by": "name",
                        "show-by": "name",
                        placeholder: "Category",
                        "show-close": true,
                        onSubmit: _cache[4] || (_cache[4] = (val) => _ctx.filterStores(val, 'category')),
                        onClose: _cache[5] || (_cache[5] = (val) => _ctx.filterStores({name: '', value: ''}, 'category'))
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.selectedOwnerFilter,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedOwnerFilter) = $event)),
                        "return-by": "'name'",
                        items: _ctx.Owners,
                        "track-by": "name",
                        "filter-by": "name",
                        "show-by": "name",
                        placeholder: "Owner",
                        "show-close": true,
                        onSubmit: _cache[7] || (_cache[7] = (val) => _ctx.filterStores(val, 'owner')),
                        onClose: _cache[8] || (_cache[8] = (val) => _ctx.filterStores({name: '', value: ''}, 'owner'))
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.selectedWorkingFilter,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedWorkingFilter) = $event)),
                        "return-by": "'Value'",
                        items: [
                    { Id: 'true', Value: 'Working' },
                    { Id: 'false', Value: 'Not Working' },
                  ],
                        "track-by": "Value",
                        "filter-by": "Value",
                        "show-by": "Value",
                        placeholder: "Working",
                        "show-close": true,
                        onSubmit: _cache[10] || (_cache[10] = (val) => _ctx.filterStores(val, 'working')),
                        onClose: _cache[11] || (_cache[11] = (val) => _ctx.filterStores({name: '', value: ''}, 'working'))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.selectedPendingFilter,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedPendingFilter) = $event)),
                        "return-by": "'Value'",
                        items: [
                    { Id: 'true', Value: 'Yes' },
                    { Id: 'false', Value: 'No' },
                  ],
                        "track-by": "Value",
                        "filter-by": "Value",
                        "show-by": "Value",
                        placeholder: "Pending",
                        "show-close": true,
                        onSubmit: _cache[13] || (_cache[13] = (val) => _ctx.filterStores(val, 'pending')),
                        onClose: _cache[14] || (_cache[14] = (val) => _ctx.filterStores({name: '', value: ''}, 'pending'))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_AutoComplete, {
                        modelValue: _ctx.selectedStatusStoreFilter,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedStatusStoreFilter) = $event)),
                        "return-by": "'Value'",
                        items: _ctx.StoreStatuses,
                        "track-by": "Value",
                        "filter-by": "Value",
                        "show-by": "Value",
                        placeholder: "Status",
                        "show-close": true,
                        onSubmit: _cache[16] || (_cache[16] = (val) => _ctx.filterStores(val, 'status')),
                        onClose: _cache[17] || (_cache[17] = (val) => _ctx.filterStores({name: '', value: ''}, 'status'))
                      }, null, 8, ["modelValue", "items"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_AutoComplete, {
            class: "w-48",
            modelValue: _ctx.selectedStoreFilter,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedStoreFilter) = $event)),
            "return-by": "'Name'",
            items: _ctx.Stores,
            "track-by": "name",
            "filter-by": "name",
            "show-by": "name",
            placeholder: "Store",
            "show-close": true,
            onSubmit: _cache[19] || (_cache[19] = (val) => _ctx.filterStores(val, 'store')),
            onClose: _cache[20] || (_cache[20] = (val) => _ctx.filterStores({name: '', value: ''}, 'store'))
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_AutoComplete, {
            class: "w-48",
            modelValue: _ctx.selectedCategoryFilter,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedCategoryFilter) = $event)),
            "return-by": "'name'",
            items: _ctx.Categories,
            "track-by": "name",
            "filter-by": "name",
            "show-by": "name",
            placeholder: "Category",
            "show-close": true,
            onSubmit: _cache[22] || (_cache[22] = (val) => _ctx.filterStores(val, 'category')),
            onClose: _cache[23] || (_cache[23] = (val) => _ctx.filterStores({name: '', value: ''}, 'category'))
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_AutoComplete, {
            class: "w-48",
            modelValue: _ctx.selectedOwnerFilter,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selectedOwnerFilter) = $event)),
            "return-by": "'name'",
            items: _ctx.Owners,
            "track-by": "name",
            "filter-by": "name",
            "show-by": "name",
            placeholder: "Owner",
            "show-close": true,
            onSubmit: _cache[25] || (_cache[25] = (val) => _ctx.filterStores(val, 'owner')),
            onClose: _cache[26] || (_cache[26] = (val) => _ctx.filterStores({name: '', value: ''}, 'owner'))
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_AutoComplete, {
            class: "w-48",
            modelValue: _ctx.selectedWorkingFilter,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.selectedWorkingFilter) = $event)),
            "return-by": "'Value'",
            items: [
              { Id: 'true', Value: 'Working' },
              { Id: 'false', Value: 'Not Working' },
            ],
            "track-by": "Value",
            "filter-by": "Value",
            "show-by": "Value",
            placeholder: "Working",
            "show-close": true,
            onSubmit: _cache[28] || (_cache[28] = (val) => _ctx.filterStores(val, 'working')),
            onClose: _cache[29] || (_cache[29] = (val) => _ctx.filterStores({name: '', value: ''}, 'working'))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_AutoComplete, {
            class: "w-48",
            modelValue: _ctx.selectedPendingFilter,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectedPendingFilter) = $event)),
            "return-by": "'Value'",
            items: [
              { Id: 'true', Value: 'Yes' },
              { Id: 'false', Value: 'No' },
            ],
            "track-by": "Value",
            "filter-by": "Value",
            "show-by": "Value",
            placeholder: "Pending",
            "show-close": true,
            onSubmit: _cache[31] || (_cache[31] = (val) => _ctx.filterStores(val, 'pending')),
            onClose: _cache[32] || (_cache[32] = (val) => _ctx.filterStores({name: '', value: ''}, 'pending'))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_AutoComplete, {
            class: "w-48",
            modelValue: _ctx.selectedStatusStoreFilter,
            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.selectedStatusStoreFilter) = $event)),
            "return-by": "'value'",
            items: _ctx.StoreStatuses,
            "track-by": "value",
            "filter-by": "value",
            "show-by": "value",
            placeholder: "Status",
            "show-close": true,
            onSubmit: _cache[34] || (_cache[34] = (val) => _ctx.filterStores(val, 'status')),
            onClose: _cache[35] || (_cache[35] = (val) => _ctx.filterStores({name: '', value: ''}, 'status'))
          }, null, 8, ["modelValue", "items"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Stores, ({
              logoImage,
              name,
              category,
              address,
              email,
              totalRatings,
              id,
              status,
              member,
              autoOpenClose,
            }, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "box justify-between min-w-max",
            key: idx
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_router_link, {
                to: `/store/${_ctx.Id}`,
                class: "w-14"
              }, {
                default: _withCtx(() => [
                  (logoImage !== '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: logoImage,
                        class: "store-icon"
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: `/store/${id}`,
                class: "w-44 capitalize"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: `/store/${id}`,
                class: "w-24"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(category.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: `/store/${id}`,
                class: "w-48"
              }, {
                default: _withCtx(() => [
                  (address?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(address, (addr, index) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "text",
                            key: index
                          }, _toDisplayString(addr?.street +
                    " " +
                    addr?.number +
                    " " +
                    addr?.zipCode +
                    ", " +
                    addr?.city +
                    ", " +
                    addr?.country), 1))
                        }), 128))
                      ]))
                    : address
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(address?.street +
                  " " +
                  address?.number +
                  " " +
                  address?.zipCode +
                  ", " +
                  address?.city +
                  ", " +
                  address?.country), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_22, "No address"))
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: `/store/${id}`,
                class: "w-44"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_23, _toDisplayString(email), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: `/store/${id}`,
                class: "flex flex-col w-36"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member, (owner, i) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "text truncate capitalize",
                      key: i
                    }, _toDisplayString(owner.user.firstName + " " + owner.user.lastName), 1))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_router_link, {
                to: `/store/${id}`,
                class: "flex justify-center w-16"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(totalRatings || "No rating"), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: `input-${idx}`,
                    class: "hidden",
                    checked: status !== 'disabled',
                    onChange: ($event: any) => (_ctx.updateWorking(id, status !== 'disabled')),
                    disabled: status !== 'verified' || autoOpenClose
                  }, null, 40, _hoisted_27),
                  _createElementVNode("label", {
                    for: `input-${idx}`,
                    id: "toggle",
                    class: "bg-[#D1E8B4] cursor-pointer h-5 relative rounded-full w-9"
                  }, null, 8, _hoisted_28)
                ]),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("input", {
                      class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none checked:border-transparent focus:ring-offset-0 focus:ring-0 focus:text-[#ed5151] transition duration-200 float-left cursor-pointer",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckChecked",
                      checked: autoOpenClose,
                      onChange: ($event: any) => (_ctx.updateAutoOpenClose(id, !autoOpenClose))
                    }, null, 40, _hoisted_32)
                  ]),
                  _hoisted_33
                ])
              ])
            ]),
            _createElementVNode("div", {
              id: `select-${idx}`,
              class: "flex gap-4 items-center"
            }, [
              _createVNode(_component_AutoComplete, {
                class: "w-32",
                modelValue: _ctx.selectedStatus[idx],
                "onUpdate:modelValue": ($event: any) => ((_ctx.selectedStatus[idx]) = $event),
                items: _ctx.StoreStatuses,
                "track-by": "value",
                "show-by": "value",
                placeholder: "Status",
                "filter-by": "value",
                "disabled-input": true,
                onSubmit: (val) => _ctx.updateStatus(id, _ctx.selectedStatus[idx], val)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onSubmit"]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_action, {
                  index: `action-${idx}`,
                  Id: id
                }, null, 8, ["index", "Id"])
              ])
            ], 8, _hoisted_34)
          ]))
        }), 128)),
        _createVNode(_component_PaginationView, {
          pagination: _ctx.Pagination,
          onUpdatePage: _ctx.updateData
        }, null, 8, ["pagination", "onUpdatePage"]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_Loader)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      ])
    ])
  ]))
}